import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Header from './Header';
import HomeRedirect from 'app/components/HomeRedirect';

import {
  verify2FACode
} from 'shared/actions/userActions';

import {
  login as loginPath
} from 'app/routes';

const TwoFactorAuthentication = props => {
  const {
    providedEmail,
    providedPass,
  } = props;

  const [state, setState] = useState({
    submitting: false,
    error: null,
    emailError: false,
    authenticated: false,
  });

  const emailRef = useRef('');
  const passwordRef = useRef('');
  const twoFactorCodeRef = useRef('');

  const user = useSelector(state => state.userReducer.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const onEmailChange = event => {
    emailRef.current = event.target.value
  }

  const onPasswordChange = event => {
    passwordRef.current = event.target.value;
  }

  const onTwoFactorCodeChange = event => {
    twoFactorCodeRef.current = event.target.value;
  }

  const onSubmit = async event => {
    event.preventDefault();

    setState(state => ({
      ...state,
      submitting: true
    }));

    let params = {
      email: providedEmail,
      password: providedPass,
      one_time_password: twoFactorCodeRef.current
    }

    try {
      await dispatch(verify2FACode(params));

      setState(state => ({
        ...state,
        authenticated: true
      }))

    } catch(err) {
      setState(state => ({
        ...state,
        error: err.error
      }));
    }
  }

  if (user && state.authenticated) {
    return <HomeRedirect />;
  }

  return (
    <Form className="login-form" onSubmit={onSubmit}>
      <Header />
      <h2>Two-Factor Authentication</h2>
      <p>Please enter the 2-factor authentication code generatedby your authenticator application.</p>
      {state.error && <p className="error">{state.error}</p>}
      <div>
        <Form.Group>
          <Form.Label htmlFor="code">Enter Code</Form.Label>
          <Form.Control className={state.emailError ? 'error' : ''}
            type="text"
            name="code"
            placeholder="Enter the 2-factor authentication code"
            onChange={onTwoFactorCodeChange}
          />
        </Form.Group>
        <Button variant="primary" className="bs-btn bs-btn-primary full-width" type="submit">
          <span>Submit</span>
        </Button>
      </div>
      <Button className="bs-btn bs-btn-default full-width" type="button" onClick={() => history.push(homePath)}>
        <span>Back to Login</span>
      </Button>
    </Form>
  )
}

export default TwoFactorAuthentication;
